import type { ReactNode } from 'react';

/**
 * 스켈레톤처럼 눈으로만 보이는 자리 표시에 붙이는 상태 안내.
 * 스켈레톤은 aria-hidden이라 이 안내가 없으면 보조 기기는 로딩 중임을 알 수 없다. 화면에는 나오지 않고 한 번만 읽힌다.
 */
export function LoadingAnnouncement({
  children,
  visible = false,
}: {
  children: ReactNode;
  visible?: boolean;
}) {
  return (
    <p
      role="status"
      aria-live="polite"
      className={visible ? 'body-sm text-muted-foreground py-3' : 'sr-only'}
    >
      {children}
    </p>
  );
}
